export default __webpack_public_path__ + "static/media/neteller.50dd6c05.svg";